const styles = () => ({
  textField: {
    width: '100%',
    justifyContent: 'center'
  },
  checkCircle: { color: '#0071CE' }
});

export default styles;
